export default __webpack_public_path__ + "static/media/user-setting.342aaf43.svg";